/**
 * useSparks — react-query wrapper around GET /sparks.
 *
 * Mirrors v1's `apps/console/src/api/hooks.ts:useSparks` shape so the
 * v2 Header can render the same credit pill v1 has, sharing the same
 * `getSparks` API method out of `@ponpon/api-client`.
 *
 * Local-dev (no auth) also fetches because the backend resolves
 * unauthenticated requests to `debug-user` and returns that user's
 * balance — matches v1's `_isLocalDev` carve-out.
 */
import { useQuery } from '@tanstack/react-query'
import { api } from '@ponpon/api-client'
import { useAuth } from '../contexts/AuthContext'

const isLocalDev =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')

export interface SparksData {
  balance: number
}

export function useSparks() {
  const { session } = useAuth()
  return useQuery<SparksData>({
    queryKey: ['sparks'],
    queryFn: () => api.getSparks(),
    enabled: !!session || isLocalDev,
    staleTime: 30_000,
    refetchOnWindowFocus: true,
  })
}
